import { Box } from '@mui/material';
import { WsColors } from 'wisestep-base';

import AllCommunicationsLog from '../../../conversationWidget/components/CommunicationsLog';
import { useCandidateViewData } from '../../utils/CandidateViewContext';

const CommunicationLogs = () => {
  const { candidateViewData } = useCandidateViewData();

  return (
    <>
      {candidateViewData && (
        <Box
          mt={1.5}
          mb={2.5}
          sx={{
            boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.12)',
            bgcolor: WsColors.White,
            borderRadius: 1.5,
            padding: 1,
            overflow: 'hidden',
          }}
        >
          <AllCommunicationsLog type="CANDIDATE" entityId={candidateViewData.id ?? ''} />
        </Box>
      )}
    </>
  );
};

export default CommunicationLogs;
